import { VehicleMappingRowItem } from "../../queries/useSearchPartPackagesByVehicle";

export const createVehicleMappingKey = ({
  vehicleModelId,
  vehicleSubmodelId,
  vehicleYearId,
}: Pick<
  VehicleMappingRowItem,
  "vehicleModelId" | "vehicleSubmodelId" | "vehicleYearId"
>): string => `${vehicleModelId}-${vehicleSubmodelId}-${vehicleYearId}`;
